import React from 'react';

const WhatsAppSection = () => {
  return (
    <>
      <style jsx>{`
        .whatsapp-section {
          background: white;
          padding: 40px;
          position: relative;
          overflow: hidden;
        }

        .whatsapp-container {
          max-width: 1400px;
          margin: 0 auto;
          position: relative;
          z-index: 2;
        }

        .whatsapp-card {
          border: 3px solid #2196F3;
          border-radius: 20px;
          padding: 40px;
          background: white;
          display: flex;
          align-items: center;
          justify-content: space-between;
          gap: 40px;
          box-shadow: 0 10px 30px rgba(33, 150, 243, 0.1);
          position: relative;
          overflow: hidden;
          animation: slideInFromBottom 0.8s ease-out;
        }

        .whatsapp-card::before {
          content: '';
          position: absolute;
          top: 0;
          left: -100%;
          width: 100%;
          height: 100%;
          background: linear-gradient(90deg, transparent, rgba(33, 150, 243, 0.05), transparent);
          animation: cardShine 4s ease-in-out infinite;
        }

        @keyframes cardShine {
          0% { left: -100%; }
          100% { left: 100%; }
        }

        @keyframes slideInFromBottom {
          from {
            opacity: 0;
            transform: translateY(50px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }

        .whatsapp-content {
          flex: 1;
          z-index: 2;
        }

        .whatsapp-title {
          font-size: 1.8rem;
          font-weight: bold;
          color: #666;
          margin: 0 0 20px 0;
          font-family: 'Arial', sans-serif;
          line-height: 1.3;
          animation: fadeInLeft 0.8s ease-out 0.2s both;
        }

        .whatsapp-description {
          display: flex;
          align-items: flex-start;
          gap: 15px;
          font-size: 1.3rem;
          color: #666;
          line-height: 1.6;
          margin: 0;
          font-family: 'Arial', sans-serif;
          animation: fadeInLeft 0.8s ease-out 0.4s both;
        }

        .chat-icon {
          font-size: 1.5rem;
          color: #2196F3;
          margin-top: 2px;
          animation: bounce 2s ease-in-out infinite;
        }

        @keyframes bounce {
          0%, 20%, 50%, 80%, 100% {
            transform: translateY(0);
          }
          40% {
            transform: translateY(-8px);
          }
          60% {
            transform: translateY(-4px);
          }
        }

        .whatsapp-button {
          background: #25D366;
          color: white;
          border: none;
          border-radius: 15px;
          padding: 20px 40px;
          font-size: 1.6rem;
          font-weight: bold;
          cursor: pointer;
          display: flex;
          align-items: center;
          gap: 15px;
          text-decoration: none;
          transition: all 0.3s ease;
          box-shadow: 0 8px 25px rgba(37, 211, 102, 0.3);
          position: relative;
          overflow: hidden;
          animation: fadeInRight 0.8s ease-out 0.6s both;
          z-index: 2;
        }

        .whatsapp-button::before {
          content: '';
          position: absolute;
          top: 0;
          left: -100%;
          width: 100%;
          height: 100%;
          background: linear-gradient(90deg, transparent, rgba(255,255,255,0.3), transparent);
          animation: buttonShine 3s ease-in-out infinite;
        }

        @keyframes buttonShine {
          0% { left: -100%; }
          100% { left: 100%; }
        }

        .whatsapp-button:hover {
          background: #128C7E;
          transform: translateY(-3px);
          box-shadow: 0 12px 35px rgba(37, 211, 102, 0.4);
        }

        .whatsapp-button:active {
          transform: translateY(-1px);
        }

        .whatsapp-button:focus {
          outline: 3px solid rgba(37, 211, 102, 0.5);
          outline-offset: 2px;
        }

        .whatsapp-icon-10 {
          width: 40px;
          height: 40px;
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 24px;
          animation: pulse 2s ease-in-out infinite;
        }

        .whatsapp-icon-10 img {
          width: 100%;
          height: 100%;
          object-fit: contain;
        }

        @keyframes pulse {
          0%, 100% {
            transform: scale(1);
          }
          50% {
            transform: scale(1.1);
          }
        }

        @keyframes fadeInLeft {
          from {
            opacity: 0;
            transform: translateX(-30px);
          }
          to {
            opacity: 1;
            transform: translateX(0);
          }
        }

        @keyframes fadeInRight {
          from {
            opacity: 0;
            transform: translateX(30px);
          }
          to {
            opacity: 1;
            transform: translateX(0);
          }
        }

        @media (max-width: 1024px) {
          .whatsapp-card {
            flex-direction: column;
            text-align: center;
            gap: 30px;
            padding: 35px;
          }

          .whatsapp-title {
            font-size: 1.6rem;
          }

          .whatsapp-description {
            font-size: 1.2rem;
            justify-content: center;
          }

          .whatsapp-button {
            font-size: 1.4rem;
            padding: 18px 35px;
          }
        }

        @media (max-width: 768px) {
          .whatsapp-section {
            padding: 30px 20px;
          }

          .whatsapp-card {
            padding: 30px 25px;
            gap: 25px;
          }

          .whatsapp-title {
            font-size: 1.4rem;
          }

          .whatsapp-description {
            font-size: 1.1rem;
            flex-direction: column;
            text-align: center;
            gap: 10px;
          }

          .whatsapp-button {
            font-size: 1.3rem;
            padding: 15px 30px;
            width: 100%;
            justify-content: center;
          }

          .whatsapp-icon-10 {
            width: 35px;
            height: 35px;
            font-size: 20px;
          }
        }

        @media (max-width: 480px) {
          .whatsapp-card {
            padding: 25px 20px;
            gap: 20px;
          }

          .whatsapp-title {
            font-size: 1.2rem;
          }

          .whatsapp-description {
            font-size: 1rem;
          }

          .whatsapp-button {
            font-size: 1.2rem;
            padding: 12px 25px;
          }

          .whatsapp-icon-10 {
            width: 30px;
            height: 30px;
            font-size: 18px;
          }
        }

        /* SEO and Accessibility improvements */
        .sr-only {
          position: absolute;
          width: 1px;
          height: 1px;
          padding: 0;
          margin: -1px;
          overflow: hidden;
          clip: rect(0, 0, 0, 0);
          white-space: nowrap;
          border: 0;
        }
      `}</style>

      <section 
        className="whatsapp-section"
        role="region"
        aria-labelledby="whatsapp-heading"
        itemScope
        itemType="https://schema.org/ContactPoint"
      >
        <div className="whatsapp-container">
          <div className="whatsapp-card">
            <div className="whatsapp-content">
              <h2 
                id="whatsapp-heading"
                className="whatsapp-title"
                itemProp="name"
              >
                Vous avez une question ou vous souhaitez réserver<br />
                immédiatement ?
              </h2>
              
              <p 
                className="whatsapp-description"
                itemProp="description"
              >
                <span className="chat-icon" role="img" aria-label="Chat">💬</span>
                Contactez-nous directement sur WhatsApp, notre équipe vous<br />
                répond en quelques minutes !
              </p>
            </div>

            <a 
              href="https://wa.me/212702094593"
              className="whatsapp-button"
              role="button"
              aria-label="Contacter Faucon Bleu sur WhatsApp"
              itemProp="url"
              target="_blank"
              rel="noopener noreferrer"
            >
              <div className="whatsapp-icon-10">
                <img 
                  src='/images/whatsapp.png' 
                  alt="WhatsApp"
                  loading="lazy"
                  width="40"
                  height="40"
                />
              </div>
              Whatsapp
            </a>
          </div>
        </div>

        {/* Structured Data for SEO */}
        <script 
          type="application/ld+json"
          dangerouslySetInnerHTML={{
            __html: JSON.stringify({
              "@context": "https://schema.org",
              "@type": "ContactPoint",
              "contactType": "Customer Service",
              "availableLanguage": ["French", "Arabic"],
              "contactOption": "TollFree",
              "areaServed": {
                "@type": "City",
                "name": "Casablanca",
                "addressCountry": "MA"
              },
              "hoursAvailable": {
                "@type": "OpeningHoursSpecification",
                "dayOfWeek": [
                  "Monday",
                  "Tuesday", 
                  "Wednesday",
                  "Thursday",
                  "Friday",
                  "Saturday"
                ],
                "opens": "08:00",
                "closes": "18:00"
              },
              "serviceChannel": {
                "@type": "ServiceChannel",
                "serviceType": "WhatsApp",
                "serviceUrl": "https://wa.me/212702094593"
              }
            })
          }}
        />
      </section>
    </>
  );
};

export default WhatsAppSection;